import { Injectable, NgZone } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from './user/user.service';
import { NativeCheckService } from './native-check.service';

@Injectable({
  providedIn: 'root'
})
export class NotFoundGuard {

  public constructor(
    private userService: UserService,
    private router: Router,
    private zone: NgZone,
    private nativeCheckService: NativeCheckService,
  ) { }

  public canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!this.userService.loggedUser) {
      if(this.nativeCheckService.isNativePlatform()) {
        this.zone.run(() => {
          this.router.navigate(['/login']);
        });
      } else {
        this.router.navigate(['/login']);
      }
      return false;
    }

    return true;
  }
}